import React , { useState } from "react";


import {
  CardBody,
 
  Table,
 
  Label
  

  
} from "reactstrap";


import { Grid } from '@mui/material';
// Redux
import { useDispatch, useSelector} from "react-redux";
import {useHistory , Link } from "react-router-dom";




//Action
import {casosUpdate} from '../../../store/casos/actions'


import styles from "../styles/Casos.module.scss"

const ListaCasos = (props) => {

    const dispatch= useDispatch();
    const history= useHistory();
    const [rangofechas, setRangoFechas] = useState([]);
    console.log(setRangoFechas)
    console.log(rangofechas)
    const user = JSON.parse(localStorage.getItem("user"))
    const groups =String(user.groups);
    const user_permissions = String(user.user_permissions)
    console.log(user_permissions)

    const casos = useSelector(state=>state.Casos.casos)
  
    const grupotTecnico = useSelector(state => state.GrupoTecnico.grupotecnico.results) || []

    const [list, setlist] = useState([{}])
    const handleaddclick= (info) => {
        setlist([...list,{}])
        const casoFilterEstatus = props.casos && props.casos.filter(item=> item.id === info)
      
    
    
        const ESTATUS = ["ASIGNADO","ACEPTAR","INICIAR","FINALIZAR","EN ESPERA", "PAUSAR","REINICIAR"]
        
    
        const Compara = ESTATUS && ESTATUS.filter(item=> item === casoFilterEstatus[0].estatus )
        
    
        let nuevoEstado = ''
        switch (Compara[0]){
          case "ASIGNADO":
            
          nuevoEstado = "ACEPTAR"
        
          break;
    
          case "ACEPTAR":
            
            nuevoEstado = "INICIAR"
           
            break;
            case "INICIAR":
              
              nuevoEstado = "FINALIZAR"
              
              break;
              case "PAUSAR":
              
              nuevoEstado = "REINICIAR"
              
              break;
             
    
          
           
           
            default:
              console.log("Default")
    
    
    
    
        }
    
        const [sd] = grupotTecnico && grupotTecnico.filter(item => item.nombre === casoFilterEstatus[0].grupo_tecnico)
    
        const  Nombre = casoFilterEstatus[0].Nombre
        const correo = casoFilterEstatus[0].correo
        const telefono = casoFilterEstatus[0].telefono
        const direccion = casoFilterEstatus[0].direccion
        const tipo_visita = casoFilterEstatus[0].tipo_visita
        const grupo_tecnico = sd.id
        const estatus = nuevoEstado
    
    
        const formData ={ 
          id:casoFilterEstatus[0].id,
          Nombre:casoFilterEstatus[0].Nombre,
          correo:casoFilterEstatus[0].correo,
          telefono:casoFilterEstatus[0].telefono,
          direccion:casoFilterEstatus[0].direccion,
          tipo_visita:casoFilterEstatus[0].tipo_visita,
          grupo_tecnico:sd.id,
         
          estatus:nuevoEstado,
        }
        setlist(formData)
        
    
    
        dispatch(casosUpdate(formData.id,{
      
          Nombre,
          correo,
          telefono,
          direccion,
          tipo_visita,
          estatus,
          grupo_tecnico
        }))
        
       
    
      }

      const  handleEspera = (id)=>{
    
          
        history.push(`/casos/${id}/edit_caso`);
        
        
      }


      const [checked, setchecked] = useState(false);

      const changeLista = (e) => {
        setchecked(e.target.checked)
      }

      const handleShow = (id) =>{ 
        history.push(`/casos/${id}/edit_caso`);
        }
     
    return ( 
        <React.Fragment>
          {casos.length !== 0 ? (
            <>

                 {/* Check para ver en lista */}
                 <div className="form-check form-switch mb-3">
                 <input className="form-check-input mt-3 mx-1" type="checkbox" id="flexSwitchCheckChecked" onChange={changeLista} checked = {checked} />
                 <Label className="form-check-label mt-3 " for="flexSwitchCheckChecked">Ver en Lista</Label>
                </div>
    {/* Tabla                         */}
                        {checked && (
 
            <div className="table-responsive ">


              <Table
                      className="table table-bordered table-striped text-center mb-3"
                      hover
                    >
                    <thead>
                        <tr>
                          <th>Numero</th>
                          <th>Fecha de Creacion </th>
                          <th>Fecha de Asignacion </th>
                          <th>Lapso de Hora para ir </th>
                          
                    

                          <th>Contacto o PreContacto </th>
                          <th>Estatus </th>
                          <th>Grupo de Tecnicos </th>

                          <th>Tecnico asignado </th>
                          <th>Accion </th>
                        </tr>
                    </thead>
                    <tbody>
                    
                      { Array.isArray (casos) ? casos.map(item => {

                        

                        const estatusinabilit = item.estatus
                      
                          return(
                            
                            <tr key={item.id}>
                              
                              <th><Link to={`/casos/${item.id}/edit_caso`}> {item.id}</Link></th>
                              <th> {item.created_date}</th>
                              <th> {item.fecha_asignacion}</th>
                              {item.estatus === 'EN ESPERA'  ? 
                              <th>  </th>

                                                                          
                                
                                
                              
                                :   (   <th> 

                                                                          
                            {item.lapso_hora_entrada}    a {item.lapso_hora_salida} 
                              
                            </th>)}  
                              <th> {item.pre_contacto === null? item.contacto:item.pre_contacto}</th>
                            
                              <th>
                              {
                              (
                                function Status() {
                                  if (item.estatus === "ACEPTAR"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-danger  font-size-13"><strong>ACEPTADO</strong> </div>
                                    );
                                  }
                                  if (item.estatus === "INICIAR"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-dark
                                    font-size-13"><strong>INICIADO</strong> </div>
                                    );
                                  }
                                  if (item.estatus === "ASIGNADO"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-warning  font-size-13"><strong>ASIGNADO</strong> </div>
                                    );
                                  }
                                  if (item.estatus === "PAUSAR"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-secondary  font-size-13"><strong>PAUSADO</strong> </div>
                                    );
                                  }
                                  if (item.estatus === "FINALIZAR"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-success font-size-13"><strong>FINALIZADO</strong> </div>
                                    );
                                  }

                                  if (item.estatus === "EN ESPERA"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-info font-size-13"><strong>EN ESPERA</strong> </div>
                                    );
                                  }
                                  if (item.estatus === "REINICIAR"){                                          
                                    return(
                                    <div className ="badge rounded-pill bg-info font-size-13"><strong>REINICIADO</strong> </div>
                                    );
                                  }
                                
                                  
                                
                              })()}
                              
                              </th>

                              <td>  
                              {item.grupo_tecnico }
                            </td>
                              <td style={{width: "225.22222px"}}>  
                              {item.tecnico_asignado.join(", ") }
                            </td>

                              <th>
                              
                              <button 
                              className="btn btn-primary waves-effect waves-light"
                              id="disabled"
                              
                              onClick={(e) => item.estatus === 'EN ESPERA' ? handleEspera(item.id) : handleaddclick(item.id)}


                              disabled={estatusinabilit === 'FINALIZAR' || ((groups === 'SuperAdmin' || groups === 'Supervisor') && item.estatus !== 'EN ESPERA' ) ? true : false}    
                              >
                                
                                  {item.estatus ==='FINALIZAR' ? 'FINALIZADO': 
                                  item.estatus ==='ASIGNADO' ? 'ACEPTAR':
                                  item.estatus ==='ACEPTAR' ? 'INICIAR':
                                  item.estatus ==='EN ESPERA' ? 'ASIGNAR':
                                  item.estatus ==='PAUSAR' ? 'REINICIAR':
                                  item.estatus ==='INICIAR' ? 'FINALIZAR':
                                  item.estatus ==='REINICIAR' ? 'PAUSAR':''

                                  }

                              </button>
                              </th>
                              
                            </tr>
                            
                          )
                        }) : []
                      }
                    
                    </tbody>
              </Table>
            </div>
        )}

             {/* Cuadros */}
                        
             {!checked && (
               <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} className='p-5 pt-2'>
               {Array.isArray(casos)? casos.map((casos,idx) => ( 
 

                 <Grid  item   md={4} key ={idx} >    
                   <div className = {`${styles.card}`} onClick={() => handleShow(casos.id)} >

                       <div className={`${styles['card-details']}`}>                            
                           <h3 className="text-primary">Caso Numero: {casos.id}</h3> 
                           <div className="text-primary mt-3 "><strong> Contacto</strong></div> 
                           <div>{casos.contacto}</div>   
                           <div className="text-primary mb-6"><strong>Estatus</strong> </div>   
                           {casos.estatus === "ACEPTAR" ? (
                                               <div className ="badge rounded-pill bg-danger  font-size-13">
                                                <strong>ACEPTADO</strong>
                                              </div>
                                            ) : 
                                            casos.estatus === "INICIAR" ? (
                                              <div className ="badge rounded-pill bg-dark
                                                    font-size-13">
                                                <strong>INICIADO</strong>
                                              </div>
                                            ) : 
                                            casos.estatus === "ASIGNADO" ? (
                                              <div className ="badge rounded-pill bg-warning  font-size-13">
                                                <strong>ASIGNADO</strong>
                                              </div>
                                            ) : 
                                            casos.estatus === "PAUSAR" ? (
                                              <div className ="badge rounded-pill bg-secondary  font-size-13">
                                                <strong>PAUSADO</strong>
                                              </div>
                                            ) : 
                                            casos.estatus === "FINALIZAR" ? (
                                              <div className ="badge rounded-pill bg-success font-size-13">
                                                <strong>FINALIZADO</strong>
                                              </div>
                                            ) : 
                                            casos.estatus === "EN ESPERA" ? (
                                              <div className ="badge rounded-pill bg-info font-size-13">
                                                <strong>EN ESPERA</strong>
                                              </div>
                                            ) : 
                                            casos.estatus === "REINICIAR" ? (
                                              <div className ="badge rounded-pill bg-info font-size-13">
                                                <strong>REINICIADO</strong>
                                              </div>
                                            ) : null

                                            
                                            }
                         
                                                          
                             
                           { casos.estatus!=="EN ESPERA" ? (
                            <>
                            <div className="text-primary mb-6"><strong>Fecha de asignacion</strong> </div>
                            <div>{casos.fecha_asignacion}</div>
                            <div className="text-primary mb-6"><strong>Tecnico asignado</strong> </div>
                            <div>{casos.tecnico_asignado}</div>
                            </> 
                           ):null}

                       </div>  
                   </div>                
                 </Grid>
             )) : []}

           </Grid>
              )}

      </>
          ) : (
            <CardBody>
            <h4 className="card-title">No se encontraron resultados</h4>
          </CardBody>
          )}

        </React.Fragment>
     );
}
 
export default ListaCasos;